import React from "react";
import { motion } from "framer-motion";
import { CONSTANTS } from "../../data";
import { AlertTriangle, X } from "lucide-react";

interface ResetConfirmModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ResetConfirmModal: React.FC<ResetConfirmModalProps> = ({
  show,
  onCancel,
  onConfirm,
}) => {
  if (!show) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50"
      onClick={onCancel}
    >
      <motion.div
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 20 }}
        className="bg-surface rounded-lg max-w-md w-full shadow-xl border border-border-color"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-4 border-b border-border-color flex justify-between items-center">
          <h2 className="text-xl font-bold text-danger flex items-center gap-2">
            <AlertTriangle /> {CONSTANTS.UI_MESSAGES.RESET_GAME_CONFIRM_TITLE}
          </h2>
          <button onClick={onCancel} className="text-text-secondary hover:text-text-primary p-1 rounded-full hover:bg-bg-main">
            <X size={20} />
          </button>
        </div>
        <div className="p-6">
          <p className="text-text-secondary mb-4">
            {CONSTANTS.UI_MESSAGES.RESET_GAME_CONFIRM_BODY}
          </p>
          <p className="text-sm text-text-secondary">
            {CONSTANTS.UI_MESSAGES.RESET_GAME_CONFIRM_NOTE}
          </p>
        </div>
        <div className="p-4 bg-bg-main rounded-b-lg flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="bg-border-color text-text-secondary px-4 py-2 rounded-lg hover:bg-text-secondary hover:text-white transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="bg-danger text-white px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
          >
            Confirm Reset
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ResetConfirmModal;
